import * as React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

import { HorseStore } from "../../stores/HorseStore";
import { HorseForSaleListStore } from "../../stores/HorseForSaleListStore";
import { HorseForSaleStore } from "../../stores/HorseForSaleStore";
import { ConfigurationStore } from "../../stores/ConfigurationStore";

import LoadingWidget from "../common/LoadingWidget";
import { successMessage, errorMessage } from "../common/Toast";

const NONE_ID: number = -1;

export interface Props {
    horseStore: HorseStore;
    horseForSaleListStore: HorseForSaleListStore;
    configurationStore: ConfigurationStore;
    show: boolean;
}

export interface State {
    isLoading: boolean;
    wasValidated: boolean;
    isWarning: boolean;
    saleId: number;
    horseId: number;
    isShown: boolean;
}

const EmptyState = (): State => {
    return {
        isLoading: false,
        wasValidated: false,
        isWarning: false,
        saleId: NONE_ID,
        horseId: NONE_ID,
        isShown: false
    };
};

export default class NewHorseForSaleDialog extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = EmptyState();
    }

    handleOnChange = (event: React.FormEvent<HTMLInputElement>): void => {
        const target = event.currentTarget;
        const value = target.value;
        const name = target.name;

        const state = this.state;
        state[name] = value;
        this.setState(state);
    };

    resetDialog = () => {
        this.setState({
            wasValidated: false,
            isWarning: false,
            saleId: NONE_ID,
            horseId: NONE_ID,
            isShown: false
        });
    };

    handleOnChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        e.preventDefault();
        const saleId = parseInt(e.target.value, 10);
        const horseId = this.props.horseStore.horse!.id;
        this.setState({ saleId, horseId });
    };

    createNewHorse = async () => {
        const horseStore = this.props.horseStore!;
        const horse = horseStore.horse;

        try {
            await this.props.horseStore!.addHorseForSale(this.state);
            this.toggle();
            successMessage(`${horse!.name} has been added to a sale.`);
        } catch (error) {
            errorMessage(error);
        }
    };

    submit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (this.formValidation() && this.state.isLoading === false) {
            this.setState({ isLoading: true, wasValidated: false });
            this.createNewHorse();
        } else {
            this.setState({ isLoading: false, wasValidated: true });
        }
    };

    formValidation = () => {
        return this.state.saleId !== NONE_ID ? true : false;
    };

    toggle = (): void => {
        this.setState({ isShown: !this.state.isShown });
    };

    render() {
        const horseStore = this.props.horseStore!;
        const configurationStore = this.props.configurationStore!;
        const horse = horseStore.horse;
        if (!horse) {
            return <div />;
        }

        const horseSales = this.props.configurationStore.horseSales.filter(
            sale => horse.sales.findIndex(horseSale => horseSale.sale.id === sale.id) < 0
        );

        return (
            <div>
                <Modal isOpen={this.state.isShown} toggle={this.toggle} className="modal-md" centered={true}>
                    <ModalHeader toggle={this.toggle}>Add {horse.name} to a Sale</ModalHeader>
                    <ModalBody>
                        <form
                            className={"mt-3 needs-validation " + (this.state.wasValidated === true ? "was-validated" : "")}
                            noValidate={true}
                            onSubmit={e => this.submit(e)}
                        >
                            <div className="form-group">
                                <label htmlFor="name">
                                    Select the sale <span className="text-danger">*</span>
                                </label>
                                <select
                                    className="form-control"
                                    name="gait"
                                    disabled={this.state.isLoading}
                                    onChange={this.handleOnChangeSelect}
                                    value={this.state.saleId}
                                >
                                    {!this.state.isLoading && this.state.saleId === NONE_ID && <option value={NONE_ID}> - Select a Sale - </option>}
                                    {horseSales.map(sale => (
                                        <option key={sale.id} value={sale.id}>
                                            {sale.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="modal-footer px-0">
                                <button className="btn btn-secondary" type="button" onClick={this.resetDialog}>
                                    Cancel
                                </button>
                                {this.props.horseForSaleListStore!.loading && <LoadingWidget />}
                                <button className="btn btn-primary ml-auto" type="submit">
                                    Add Horse
                                </button>
                            </div>
                        </form>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/horses/NewHorseForSaleDialog.tsx